module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar navbar-default navbar-fixed-top",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/home"
    }
  }, [_vm._v("通讯管理机")])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "collapse"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown user"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.$emit('logout')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" 退出登录\n          ")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user"
  }, [_c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": "/log"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" 运行日志\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "dropdown user"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.store.showMessage($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-headphones"
  }), _vm._v(" 报文解析\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31786eb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/framework/Navbar.vue
// module id = 83
// module chunks = 0